import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";

export default class FeedbackPopupFactory {
    /**
     * @console
     * @param {MediatorManager} mediatorManager 
     */
    constructor(mediatorManager) {
        this._mediatorManager = mediatorManager;
    }


    createPopup(container, skinKey) {
        const skinConstructor = lib.MainAssets[skinKey];
        if (!skinConstructor) {
            console.error(`[MapFactory] Cannot create Popup, movie clip '${skinKey}' doesn't exists in MainAssets.`);
            return;
        }

        const skin = new skinConstructor();
        container.addChild(skin);
        return this._mediatorManager.createMediator(skin, SkinKeyRegistry.FEEDBACK_POPUP_SKIN);
    }
}